/**
 * pluralize :: (Array, String, String) -> String
 */
export const pluralize = (value, title, suffix) => {
  if (Array.isArray(value) && value.length > 1) return title + suffix;
  return title;
};



// WEBPACK FOOTER //
// ./src/utils/pluralize.js